<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Child Route View -->
      <router-view />
      <!-- end: Child Route View -->

      <div
        v-show="$route.path == '/BudgetPlan/Job'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fas fa-file-invoice-dollar"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit" ref="searchForm">
            <div class="row">
              <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label>ปีงบประมาณ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'searchYear'"
                    :name="'searchYear'"
                    :select2-options="yearOptions"
                    v-model="searchYear"
                    ref="yearSelect2"
                  ></select2>
                </div>
              </div>
              <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label>CCTR:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'searchCCTR'"
                    :name="'searchCCTR'"
                    :select2-options="cctrOptions"
                    v-model="searchCCTR"
                    ref="cctrSelect2"
                  ></select2>
                </div>
              </div>
              <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label>IO:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'searchIO'"
                    :name="'searchIO'"
                    :select2-options="ioOptions"
                    v-model="searchIO"
                    ref="ioSelect2"
                  ></select2>
                </div>
              </div>
              <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label>GL:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'searchGL'"
                    :name="'searchGL'"
                    :select2-options="glOptions"
                    v-model="searchGL"
                    ref="glSelect2"
                  ></select2>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label>แผนก:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'searchOrgCode'"
                    :name="'searchOrgCode'"
                    :select2-options="orgOptions"
                    v-model="searchOrgCode"
                    ref="orgSelect2"
                  ></select2>
                </div>
              </div>
              <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label>ประเภทใบงาน:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'searchJobType'"
                    :name="'searchJobType'"
                    :select2-options="jobTypeOptions"
                    v-model="searchJobType"
                    ref="searchJobTypeSelect2"
                  ></select2>
                </div>
              </div>
              <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label>สถานะใบงาน:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'searchStatus'"
                    :name="'searchStatus'"
                    :select2-options="statusOptions"
                    v-model="searchStatus"
                    ref="searchStatusSelect2"
                  ></select2>
                </div>
              </div>
              <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label>เลขที่ใบงาน:</label>
                  <input
                    type="text"
                    class="form-control"
                    id="searchJobNumber"
                    name="searchJobNumber"
                    v-model="searchJobNumber"
                    placeholder="ค้นหาเลขที่ใบงาน"
                  />
                </div>
              </div>
            </div>
            <!--
              FR-012 (Vendor) + CR-BudgetReport ข้อ 5 (ชื่อสินค้า · ช่วงวันที่ใบงาน)
              spec sheet 5 กำหนดให้ 4 ช่องนี้อยู่ "แถวเดียวกัน" (ISS-07)
              ชื่อสินค้า: คั่นหลายคำด้วย , เป็นเงื่อนไข OR (Q-C4) · วันที่ = JobDate (Q-C5)
            -->
            <div class="row mb-3">
              <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div class="form-group">
                  <label>Vendor:</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="searchVendor"
                    placeholder="กรุณาระบุชื่อหรือรหัส Vendor (คั่น,(ลูกน้ำ)ได้)"
                  />
                </div>
              </div>
              <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div class="form-group">
                  <label>ชื่อสินค้า:</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="searchProductName"
                    placeholder="กรุณาระบุชื่อรายการ (คั่น,(ลูกน้ำ)ได้)"
                  />
                </div>
              </div>
              <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div class="form-group">
                  <label>วันที่(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="วว/ดด/ปปปป"
                      id="jobDateFrom"
                      name="jobDateFrom"
                      ref="jobDateFrom"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div class="form-group">
                  <label>วันที่(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="วว/ดด/ปปปป"
                      id="jobDateTo"
                      name="jobDateTo"
                      ref="jobDateTo"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  <i class="fas fa-search"></i> ค้นหา
                </button>
                <button
                  type="button"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  <i class="fas fa-times"></i> ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <router-link v-if="isApprover" to="/BudgetPlan/Job/GroupApprove" class="btn btn-success">
                  <i class="fas fa-check"></i> ตรวจสอบใบงานที่ต้องอนุมัติ
                </router-link>
                <button
                  type="button"
                  class="btn btn-primary ml-2"
                  @click="goToCreate"
                >
                  <i class="fas fa-plus"></i> สร้างใบงานงบประมาณ
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="budgetPlanJobTable"
              >
                <thead>
                  <tr>
                    <th class="all text-center" style="width: 12%;">IO</th>
                    <th class="all text-center" style="width: 8%;">GL</th>
                    <th class="all text-center" style="width: 8%;">แผนก</th>
                    <th class="all text-center" style="width: 15%;">รายการสินค้า</th>
                    <th class="all text-center" style="width: 8%;">จำนวนเงิน</th>
                    <th class="all text-center" style="width: 12%;">Vendor</th>
                    <th class="all text-center" style="width: 10%;">สถานะ</th>
                    <th class="all text-center" style="width: 5%;">คำสั่ง</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import moment from "moment";
import router from "../../router";
import select2 from "../../Shared/Select2";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-bs4");
require("datatables.net-responsive-bs4");
require("sweetalert2");

let BudgetPlanJobActions = Vue.extend({
  template: `
  <div>
    <a :href="'/BudgetPlan/Job/View/' + data.id" @click.prevent="viewJob" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="ดูรายละเอียดใบงานงบประมาณ">
      <i class="fas fa-search"></i>
    </a>
    <a :href="'/BudgetPlan/Job/Edit/' + data.id" @click.prevent="editJob" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="แก้ไขรายละเอียดใบงานงบประมาณ" v-if="data.status === 0 || data.status === 5">
      <i class="la la-edit"></i>
    </a>
    <a :href="'/BudgetPlan/Job/Edit/' + data.id" @click.prevent="approveJob" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="อนุมัติใบงานงบประมาณ" v-if="data.canApprove">
      <i class="fas fa-check-circle" style="color: #5867dd;"></i>
    </a>
    <a href="#" @click.prevent="cancelJob" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="ยกเลิกใบงานงบประมาณ" v-if="data.status === 0 || data.status === 5 || (data.status === 1 && data.currentApprovalLevel <= 1)">
      <i class="la la-trash" style="color: #fd397a;"></i>
    </a>
  </div>`,
  methods: {
    viewJob: function () {
      router.push({ path: `/BudgetPlan/Job/View/${this.data.id}` });
    },
    editJob: function () {
      router.push({ path: `/BudgetPlan/Job/Edit/${this.data.id}` });
    },
    approveJob: function () {
      // Navigate to view page for approval
      router.push({ path: `/BudgetPlan/Job/View/${this.data.id}` });
    },
    cancelJob: function () {
      let self = this;
      Swal.fire({
        title: "ยืนยันการยกเลิก",
        type: "warning",
        html: `คุณต้องการยกเลิกใบงาน <strong>${this.data.jobNumber}</strong> หรือไม่?<br/><br/><span class="text-danger">หมายเหตุ: การยกเลิกจะคืนยอดงบประมาณที่ใช้ไปกลับคืน</span>`,
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        confirmButtonColor: "#dc3545",
        cancelButtonText: "ปิด",
        showLoaderOnConfirm: true,
        preConfirm: function() {
          return axios
            .delete(`/Api/BudgetPlan/Job/${self.data.id}`, {
              headers: {
                Authorization: "Bearer " + self.$root.user.access_token,
              },
            })
            .then(function(response) {
              return response.data;
            })
            .catch(function(error) {
              Swal.showValidationMessage(
                error.response && error.response.data && error.response.data.message
                  ? error.response.data.message
                  : "เกิดข้อผิดพลาด"
              );
            });
        },
        allowOutsideClick: function() { return !Swal.isLoading(); }
      }).then(function(result) {
        if (result.value) {
          if (result.value.success) {
            self.$parent.reloadDataTable();
            Swal.fire("สำเร็จ", result.value.message || "ยกเลิกใบงานเรียบร้อยแล้ว", "success");
          } else {
            Swal.fire("เกิดข้อผิดพลาด", result.value.message || "ไม่สามารถยกเลิกใบงานได้", "error");
          }
        }
      });
    },
  },
});

export default {
  components: {
    select2,
  },
  data: function () {
    // Generate year options: current year+1 to current year-4
    const currentYear = new Date().getFullYear();
    const yearData = [
      { id: (currentYear + 1).toString(), text: (currentYear + 1).toString() },
      { id: currentYear.toString(), text: currentYear.toString() },
      { id: (currentYear - 1).toString(), text: (currentYear - 1).toString() },
      { id: (currentYear - 2).toString(), text: (currentYear - 2).toString() },
      { id: (currentYear - 3).toString(), text: (currentYear - 3).toString() },
      { id: (currentYear - 4).toString(), text: (currentYear - 4).toString() },
    ];

    return {
      isApprover: false,
      searchYear: currentYear.toString(),
      searchCCTR: null,
      searchIO: null,
      searchGL: null,
      searchOrgCode: null,
      searchJobType: null,
      searchStatus: null,
      searchJobNumber: "",
      searchVendor: "", // FR-012
      // ---- CR-BudgetReport ข้อ 5 ----
      searchProductName: "",
      searchJobDateFrom: "",
      searchJobDateTo: "",
      yearOptions: {
        placeholder: "เลือกปีงบประมาณ",
        allowClear: true,
        data: yearData,
      },
      cctrOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [],
      },
      ioOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [],
      },
      glOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [],
      },
      orgOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [],
      },
      jobTypeOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [],
      },
      statusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "MY_APPROVAL", text: "ใบงานที่ต้องอนุมัติ" },
          { id: "DRAFT", text: "บันทึก" },
          { id: "RETURNED", text: "รอแก้ไขข้อมูล" },
          { id: "PENDING_L1", text: "รออนุมัติ ลำดับที่ 1" },
          { id: "PENDING_L2", text: "รออนุมัติ ลำดับที่ 2" },
          { id: "PENDING_L3", text: "รออนุมัติ ลำดับที่ 3" },
          { id: "PENDING_L4", text: "รออนุมัติ ลำดับที่ 4" },
          { id: "WAITING_CONFIRM", text: "รอยืนยัน" },
          { id: "COMPLETED", text: "ดำเนินการเรียบร้อย" },
          { id: "REJECTED", text: "ไม่อนุมัติ" },
          { id: "CANCELED", text: "ยกเลิก" },
        ],
      },
      dataTable: null,
      isReloadingDropdowns: false,
      dropdownReloadTimer: null,
    };
  },
  methods: {
    formReset: function (e) {
      const currentYear = new Date().getFullYear();
      this.searchYear = currentYear.toString();
      this.searchCCTR = null;
      this.searchIO = null;
      this.searchGL = null;
      this.searchOrgCode = null;
      this.searchJobType = null;
      this.searchStatus = null;
      this.searchJobNumber = "";
      this.searchVendor = ""; // FR-012
      this.searchProductName = "";
      this.searchJobDateFrom = "";
      this.searchJobDateTo = "";
      // ปฏิทินเป็น jQuery ไม่ผูกกับ v-model จึงต้องล้างเอง
      $(this.$refs.jobDateFrom).datepicker("update", "");
      $(this.$refs.jobDateTo).datepicker("update", "");

      // Reset all Select2 dropdowns
      $("#searchYear").val(currentYear.toString()).trigger("change");
      $("#searchCCTR").val(null).trigger("change");
      $("#searchIO").val(null).trigger("change");
      $("#searchGL").val(null).trigger("change");
      $("#searchOrgCode").val(null).trigger("change");
      $("#searchJobType").val(null).trigger("change");
      $("#searchStatus").val(null).trigger("change");

      // Reload filter dropdowns
      this.loadFilterDropdowns();

      // Reload table
      this.formSubmit(e);
    },
    formSubmit: function (e) {
      if (e) e.preventDefault();
      var dateMessage = this.validateJobDateRange();
      if (dateMessage) {
        Swal.fire("ไม่สามารถทำรายการได้", dateMessage, "warning");
        return;
      }
      var table = $("#budgetPlanJobTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function (resetPaging = false) {
      if (this.dataTable) {
        this.dataTable.ajax.reload(null, resetPaging);
      }
    },
    /**
     * ISS-99 (ผู้ใช้สั่ง 23 ต.ค. 2026) ช่วงวันที่ต้องสอดคล้องกับปีงบประมาณที่เลือก
     * ข้อความ/ลำดับเดียวกับ BudgetDateRangeRule.ValidateJobSearch ฝั่ง API · คืน null = ผ่าน
     * ปี "ทั้งหมด" ข้ามปีได้ (Q99-3) · ไม่กรอกวันที่ทั้ง 2 ช่อง = ผ่าน
     */
    validateJobDateRange: function () {
      var from = this.searchJobDateFrom ? moment(this.searchJobDateFrom, "DD/MM/YYYY", true) : null;
      var to = this.searchJobDateTo ? moment(this.searchJobDateTo, "DD/MM/YYYY", true) : null;
      if (from && !from.isValid()) from = null;
      if (to && !to.isValid()) to = null;
      if (!!from !== !!to) {
        return "โปรดระบุช่วงวันที่(เริ่มต้น)และวันที่(สิ้นสุด)ของปีงบประมาณที่ต้องการค้นหา";
      }
      if (!from) return null;
      var year = parseInt(this.searchYear, 10);
      if (!isNaN(year) && (from.year() !== year || to.year() !== year)) {
        return "โปรดระบุช่วงวันที่ภายในปีงบประมาณ " + year;
      }
      if (from.isAfter(to, "day")) {
        return "วันที่(เริ่มต้น) ต้องไม่มากกว่าวันที่(สิ้นสุด)";
      }
      return null;
    },
    /**
     * ISS-99 (Claude เสนอ · ผู้ใช้ตกลง 23 ต.ค. 2026): เลือกปีแล้ว ปฏิทินเลือกได้เฉพาะวันในปีนั้น
     * ปี "ทั้งหมด" = ไม่จำกัด · วันที่เลือกไว้ก่อนเปลี่ยนปีไม่ล้าง — ไปเจอข้อความตอนกดค้นหาแทน
     */
    applyJobDateLimits: function () {
      var year = parseInt(this.searchYear, 10);
      var start = isNaN(year) ? -Infinity : new Date(year, 0, 1);
      var end = isNaN(year) ? Infinity : new Date(year, 11, 31);
      [this.$refs.jobDateFrom, this.$refs.jobDateTo].forEach(function (el) {
        if (!el) return;
        $(el).datepicker("setStartDate", start);
        $(el).datepicker("setEndDate", end);
      });
    },
    goToCreate: function () {
      router.push({ path: "/BudgetPlan/Job/Create" });
    },
    async loadJobTypes() {
      try {
        const response = await axios.get("/Api/BudgetPlan/Job/Types", {
          headers: {
            Authorization: "Bearer " + this.$root.user.access_token,
          },
        });
        if (response.data && Array.isArray(response.data)) {
          this.jobTypeOptions.data = response.data.map((item) => ({
            id: item.value,
            text: item.text,
          }));

          await this.$nextTick();
          if (this.$refs.searchJobTypeSelect2 && this.$refs.searchJobTypeSelect2.$el) {
            const $select = $(this.$refs.searchJobTypeSelect2.$el);
            if ($select.data('select2')) {
              $select.select2('destroy');
            }
            $select.select2({
              data: this.jobTypeOptions.data,
              placeholder: this.jobTypeOptions.placeholder,
              allowClear: this.jobTypeOptions.allowClear
            });
            $select.val(null).trigger('change');
          }
        }
      } catch (error) {
        console.error("Error loading job types:", error);
      }
    },
    async loadFilterDropdowns() {
      var self = this;
      try {
        var headers = {
          Authorization: "Bearer " + this.$root.user.access_token,
        };

        // Build query params
        var params = {};
        if (self.searchYear) {
          params.year = self.searchYear;
        }

        var response = await axios.get("/Api/BudgetPlan/Job/Dropdown", {
          headers: headers,
          params: params,
        });

        if (response.data && response.data.data) {
          var data = response.data.data;

          // Update dropdown options
          self.cctrOptions.data = (data.costCenters || []).map(function(item) {
            return { id: item.value, text: item.text };
          });
          self.ioOptions.data = (data.ioCodes || []).map(function(item) {
            return { id: item.value, text: item.text };
          });
          self.glOptions.data = (data.glCodes || []).map(function(item) {
            return { id: item.value, text: item.text };
          });
          self.orgOptions.data = (data.orgCodes || []).map(function(item) {
            return { id: item.value, text: item.text };
          });

          // Refresh Select2 dropdowns
          await self.$nextTick();
          self.refreshSelect2Dropdown('cctrSelect2', 'searchCCTR', self.cctrOptions);
          self.refreshSelect2Dropdown('ioSelect2', 'searchIO', self.ioOptions);
          self.refreshSelect2Dropdown('glSelect2', 'searchGL', self.glOptions);
          self.refreshSelect2Dropdown('orgSelect2', 'searchOrgCode', self.orgOptions);
        }
      } catch (error) {
        console.error("Error loading filter dropdowns:", error);
      }
    },
    /**
     * ISS-07 · ปฏิทินช่วงวันที่ใบงาน — bootstrap-datepicker แบบเดียวกับหน้าอื่นในระบบ
     * (เทียบแบบจาก Components/PM/SearchCheckIn.vue) · รูปแบบ dd/mm/yyyy
     * เก็บค่าเป็น string ตรง ๆ — ParseFilterDate ฝั่ง API รับ dd/MM/yyyy อยู่แล้ว
     */
    initJobDatepickers: function() {
      var self = this;
      var arrows = KTUtil.isRTL()
        ? { leftArrow: '<i class="la la-angle-right"></i>', rightArrow: '<i class="la la-angle-left"></i>' }
        : { leftArrow: '<i class="la la-angle-left"></i>', rightArrow: '<i class="la la-angle-right"></i>' };

      var dpOptions = {
        autoclose: true,
        clearBtn: true,
        format: "dd/mm/yyyy",
        rtl: KTUtil.isRTL(),
        orientation: "bottom left",
        todayBtn: "linked",
        todayHighlight: true,
        templates: arrows,
      };

      $(self.$refs.jobDateFrom).datepicker(dpOptions).on("changeDate", function(e) {
        self.searchJobDateFrom = e.date ? $(self.$refs.jobDateFrom).val() : "";
      });
      $(self.$refs.jobDateTo).datepicker(dpOptions).on("changeDate", function(e) {
        self.searchJobDateTo = e.date ? $(self.$refs.jobDateTo).val() : "";
      });
      self.applyJobDateLimits();   // ISS-99
    },

    refreshSelect2Dropdown: function(refName, selectId, options) {
      var self = this;
      if (self.$refs[refName] && self.$refs[refName].$el) {
        var $select = $(self.$refs[refName].$el);
        if ($select.data('select2')) {
          $select.select2('destroy');
        }
        $select.empty();
        $select.append('<option value=""></option>');
        options.data.forEach(function(item) {
          $select.append('<option value="' + item.id + '">' + item.text + '</option>');
        });
        $select.select2({
          data: options.data,
          placeholder: options.placeholder,
          allowClear: options.allowClear
        });
        $select.val(null).trigger('change.select2');
      }
    },
    reloadDropdownsBasedOnSelection: function() {
      var self = this;

      // Clear existing timer
      if (self.dropdownReloadTimer) {
        clearTimeout(self.dropdownReloadTimer);
      }

      // Debounce: wait 300ms before calling API
      self.dropdownReloadTimer = setTimeout(async function() {
        try {
          self.isReloadingDropdowns = true;

          var headers = {
            Authorization: "Bearer " + self.$root.user.access_token,
          };

          // Build query params based on current selections
          var params = {};
          if (self.searchYear) {
            params.year = self.searchYear;
          }
          if (self.searchCCTR) {
            params.cctrCode = self.searchCCTR;
          }
          if (self.searchIO) {
            params.ioCode = self.searchIO;
          }
          if (self.searchGL) {
            params.glCode = self.searchGL;
          }
          if (self.searchOrgCode) {
            params.orgCode = self.searchOrgCode;
          }

          var response = await axios.get("/Api/BudgetPlan/Job/Dropdown", {
            headers: headers,
            params: params,
          });

          if (response.data && response.data.data) {
            var data = response.data.data;

            // Create new data arrays
            var newCctrData = (data.costCenters || []).map(function(item) {
              return { id: item.value, text: item.text };
            });
            var newIoData = (data.ioCodes || []).map(function(item) {
              return { id: item.value, text: item.text };
            });
            var newGlData = (data.glCodes || []).map(function(item) {
              return { id: item.value, text: item.text };
            });
            var newOrgData = (data.orgCodes || []).map(function(item) {
              return { id: item.value, text: item.text };
            });

            // Reload dropdowns in next tick
            // NOTE: ไม่ reload dropdown ที่มี selection อยู่แล้ว เพื่อให้ user สามารถเปลี่ยนใจเลือก item อื่นได้
            self.$nextTick(function() {
              // Reload CCTR dropdown - เฉพาะเมื่อไม่มี selection
              if (!self.searchCCTR) {
                self.reloadSelectWithValidation('cctrSelect2', 'searchCCTR', newCctrData, self.cctrOptions);
              }
              // Reload IO dropdown - เฉพาะเมื่อไม่มี selection
              if (!self.searchIO) {
                self.reloadSelectWithValidation('ioSelect2', 'searchIO', newIoData, self.ioOptions);
              }
              // Reload GL dropdown - เฉพาะเมื่อไม่มี selection
              if (!self.searchGL) {
                self.reloadSelectWithValidation('glSelect2', 'searchGL', newGlData, self.glOptions);
              }
              // Reload Org dropdown - เฉพาะเมื่อไม่มี selection
              if (!self.searchOrgCode) {
                self.reloadSelectWithValidation('orgSelect2', 'searchOrgCode', newOrgData, self.orgOptions);
              }

              self.isReloadingDropdowns = false;
            });
          }
        } catch (error) {
          console.error("Error reloading dropdowns:", error);
          self.isReloadingDropdowns = false;
        }
      }, 300);
    },
    reloadSelectWithValidation: function(refName, dataKey, newData, optionsObj) {
      var self = this;
      if (self.$refs[refName] && self.$refs[refName].$el) {
        var $select = $(self.$refs[refName].$el);
        var currentValue = self[dataKey];

        $select.select2('destroy');
        $select.empty();
        $select.append('<option value=""></option>');
        newData.forEach(function(item) {
          $select.append('<option value="' + item.id + '">' + item.text + '</option>');
        });

        optionsObj.data = newData;
        $select.select2({
          data: newData,
          placeholder: optionsObj.placeholder,
          allowClear: optionsObj.allowClear
        });

        // Check if current value is still valid
        var isValid = newData.some(function(x) { return x.id === currentValue; });
        if (currentValue && isValid) {
          self[dataKey] = currentValue;
          $select.val(currentValue).trigger('change.select2');
        } else {
          self[dataKey] = null;
          $select.val(null).trigger('change.select2');
        }
      }
    },
  },
  async mounted() {
    // ISS-07: ปฏิทินต้องผูกก่อน แล้วค่อยโหลดข้อมูลตาราง
    this.initJobDatepickers();

    // Load job types and filter dropdowns
    await this.loadJobTypes();
    await this.loadFilterDropdowns();

    let self = this;

    // Check ว่า user เป็น approver หรือไม่ (ซ่อนปุ่ม "ตรวจสอบ..." ถ้าไม่ใช่)
    axios.get("/Api/BudgetPlan/IsApprover")
      .then(function (res) { self.isApprover = res.data === true; })
      .catch(function () { self.isApprover = false; });

    // Set default year
    await this.$nextTick();
    const currentYear = new Date().getFullYear();
    $("#searchYear").val(currentYear.toString()).trigger("change");

    $.fn.dataTable.ext.errMode = "none";
    var table = $("#budgetPlanJobTable");
    self.dataTable = table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/BudgetPlan/Job/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function (request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function (d) {
            return JSON.stringify(
              $.extend(d, {
                Year: self.searchYear || "",
                CCTRCode: self.searchCCTR || "",
                IOCode: self.searchIO || "",
                GLCode: self.searchGL || "",
                OrgCode: self.searchOrgCode || "",
                JobType: self.searchJobType || "",
                StatusFilter: self.searchStatus || "",
                JobNumber: self.searchJobNumber || "",
                VendorSearch: self.searchVendor || "", // FR-012
                ProductNameSearch: self.searchProductName || "",   // ข้อ 5
                JobDateFrom: self.searchJobDateFrom || "",
                JobDateTo: self.searchJobDateTo || "",
                CurrentUserId: self.$root.user.profile.sub, // Pass current user ID for canApprove check
              })
            );
          },
        },
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,
        lengthMenu: [50, 100, 200, 500],
        pageLength: 100,
        language: {
          lengthMenu: "Display _MENU_",
        },
        order: [[0, "asc"]],
        columns: [
          // FR-012 §4.3.2: IO column with toggle +/- (ซ่อน CCTR, ประเภทใบงาน, เลขที่ใบงาน, วันที่)
          {
            data: "ioCode",
            className: "text-left dt-control",
            width: "12%",
            render: function (data, type, full, meta) {
              var ioText = data && full.ioName ? "[" + data + "] " + full.ioName : (data || "-");
              return ioText;
            },
          },
          {
            data: "glCode",
            className: "text-left",
            width: "12%",
            render: function (data, type, full, meta) {
              if (data && full.glName) {
                return `[${data}] ${full.glName}`;
              }
              return data || "-";
            },
          },
          {
            data: "orgCode",
            className: "text-left",
            width: "8%" ,
            render: function (data, type, full, meta) {
              if (data && full.orgName) {
                return `[${data}] ${full.orgName}`;
              }
              return data || "-";
            },
          },
          // FR-012: รายการสินค้า (#96: ขยาย +5%)
          {
            data: "itemsDisplay",
            className: "text-left",
            width: "20%",
            render: function (data) {
              if (!data) return "-";
              return "<small>" + data.replace(/\n/g, "<br/>") + "</small>";
            },
          },
          // FR-012: จำนวนเงินรวม
          {
            data: "totalAmount",
            className: "text-right",
            width: "8%",
            render: function (data) {
              if (data == null) return "0.00";
              return Number(data).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
          },
          // FR-012: Vendor (#96: ลด -5%)
          {
            data: "vendorName",
            className: "text-left",
            width: "7%",
            render: function (data) {
              return data || "-";
            },
          },
          {
            data: "statusName",
            className: "text-center",
            width: "8%" ,
            render: function (data, type, full, meta) {
              let badgeClass = "badge-secondary";
              let displayText = data;

              switch (full.status) {
                case 0: // DRAFT
                  badgeClass = "badge-secondary";
                  displayText = "บันทึก";
                  break;
                case 1: // PENDING_APPROVAL
                  badgeClass = "badge-warning";
                  displayText = "รออนุมัติ ลำดับที่ " + full.currentApprovalLevel;
                  break;
                case 2: // APPROVED (waiting confirm) - รอยืนยัน
                  badgeClass = "badge-info";
                  displayText = "รอยืนยัน";
                  break;
                case 3: // CONFIRMED
                  badgeClass = "badge-success";
                  displayText = "ดำเนินการเรียบร้อย";
                  break;
                case 4: // REJECTED
                  badgeClass = "badge-danger";
                  displayText = "ไม่อนุมัติ";
                  break;
                case 5: // RETURNED
                  badgeClass = "badge-warning";
                  displayText = "รอแก้ไขข้อมูล";
                  break;
                case 6: // COMPLETED
                  badgeClass = "badge-success";
                  displayText = "ดำเนินการเรียบร้อย";
                  break;
                case 7: // CANCELED
                  badgeClass = "badge-danger";
                  displayText = "ยกเลิก";
                  break;
              }
              return `<span class="badge ${badgeClass}">${displayText}</span>`;
            },
          },
          {
            data: "id",
            className: "text-center",
            width: "5%" ,
            orderable: false,
            render: function (data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("preXhr.dt", function () {
        KTApp.block(self.$refs.searchForm, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("error.dt", function (e, settings, techNote, message) {
        // ISS-99: API ปฏิเสธช่วงวันที่ (เช่น แก้วันที่แล้วเปลี่ยนหน้า/เรียงโดยไม่กดค้นหา) -> แจ้งข้อความจาก API
        var xhr = settings && settings.jqXHR;
        var apiMessage = xhr && xhr.status === 400 && xhr.responseJSON && xhr.responseJSON.message;
        if (apiMessage) {
          Swal.fire("ไม่สามารถทำรายการได้", apiMessage, "warning");
          return;
        }
        DatatableWarning.alert(techNote);
      })
      .on("xhr.dt", function () {
        KTApp.unblock(self.$refs.searchForm);
      })
      .on("draw.dt", function () {
        $(".actions").each(function (i, el) {
          var $dt = table.DataTable();
          var $tr = $(el).parents("tr").first();
          var data = $dt.row($tr).data();
          if (data) {
            new BudgetPlanJobActions({ data: { data }, parent: self }).$mount(el);
          }
        });
      });

      // FR-012 §4.3.2: Toggle child row เมื่อคลิก IO column (dt-control)
      $("#budgetPlanJobTable tbody").on("click", "td.dt-control", function () {
        var tr = $(this).closest("tr");
        var row = self.dataTable.row(tr);

        if (row.child.isShown()) {
          row.child.hide();
          tr.removeClass("shown");
        } else {
          var d = row.data();
          if (d) {
            var cctr = d.cctrCode ? "[" + d.cctrCode + "] " + (d.cctrName || "") : "-";
            var jobType = d.jobTypeName || "-";
            var jobNumber = d.jobNumber || "-";
            var lastDate = "-";
            if (d.lastModifiedDate) {
              var dt = new Date(d.lastModifiedDate);
              lastDate = String(dt.getDate()).padStart(2, "0") + "/" +
                String(dt.getMonth() + 1).padStart(2, "0") + "/" +
                dt.getFullYear() + " " +
                String(dt.getHours()).padStart(2, "0") + ":" +
                String(dt.getMinutes()).padStart(2, "0");
            }
            row.child(
              '<table class="table table-sm table-borderless mb-0" style="background:#f9f9f9;">' +
              '<tr><td><strong>CCTR:</strong> ' + cctr + '</td></tr>' +
              '<tr><td><strong>ประเภทใบงาน:</strong> ' + jobType + '</td></tr>' +
              '<tr><td><strong>เลขที่ใบงาน:</strong> ' + jobNumber + '</td></tr>' +
              '<tr><td><strong>วันที่เคลื่อนไหว:</strong> ' + lastDate + '</td></tr>' +
              '</table>'
            ).show();
            tr.addClass("shown");
          }
        }
      });

  },
  watch: {
    '$route.query.reload': function() {
      // Reload datatable when returning from form with reload query param
      if (this.dataTable) {
        this.dataTable.ajax.reload();
      }
    },
    searchYear: function(newVal, oldVal) {
      this.applyJobDateLimits();   // ISS-99
      if (oldVal !== null && newVal !== oldVal) {
        // Reset filter dropdowns when year changes
        this.searchCCTR = null;
        this.searchIO = null;
        this.searchGL = null;
        this.searchOrgCode = null;

        $("#searchCCTR").val(null).trigger("change.select2");
        $("#searchIO").val(null).trigger("change.select2");
        $("#searchGL").val(null).trigger("change.select2");
        $("#searchOrgCode").val(null).trigger("change.select2");

        // Reload dropdown data
        this.loadFilterDropdowns();
      }
    },
    searchCCTR: function(newVal, oldVal) {
      if (oldVal !== undefined && !this.isReloadingDropdowns) {
        this.reloadDropdownsBasedOnSelection();
      }
    },
    searchIO: function(newVal, oldVal) {
      if (oldVal !== undefined && !this.isReloadingDropdowns) {
        this.reloadDropdownsBasedOnSelection();
      }
    },
    searchGL: function(newVal, oldVal) {
      if (oldVal !== undefined && !this.isReloadingDropdowns) {
        this.reloadDropdownsBasedOnSelection();
      }
    },
    searchOrgCode: function(newVal, oldVal) {
      if (oldVal !== undefined && !this.isReloadingDropdowns) {
        this.reloadDropdownsBasedOnSelection();
      }
    }
  },
};
</script>

<style lang="scss">
.select2,
.select2-dropdown {
  font-size: 1rem !important;
}
/* FR-012: Toggle icon +/- for dt-control (style เดียวกับ /Jobs) */
td.dt-control {
  cursor: pointer;
}
td.dt-control::before {
  content: "+";
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: 1.5px solid #5d78ff;
  border-radius: 50%;
  font-size: 14px;
  font-weight: bold;
  color: #5d78ff;
  margin-right: 5px;
  line-height: 1;
}
tr.shown td.dt-control::before {
  content: "\2212"; /* minus sign */
}
</style>



// WEBPACK FOOTER //
// App/Components/BudgetPlan/BudgetPlanJobList.vue